import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  isModalOpen: false,
  isThinking: false,
  analysisResult: null,
  error: null,
  analysisType: null, // Can store what type of calculation was analyzed
  activeTab: null,
};


export const analyzeWithAI = createAsyncThunk('aiAnalysis/analyzeWithAI', async (data, { rejectWithValue }) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_AI_BASE_URL}/result-analysis`, 
      {
        type: "GROWLIFE",
        token:data
      }
    )
    return response.data?.data
  } catch (error) {
    console.log("🚀 ~ error:", error)
    return rejectWithValue(error.response.data.message)
  }
})


const aiAnalysisSlice = createSlice({
  name: "aiAnalysis",
  initialState,
  reducers: {
    openModal(state, { payload }) {
      state.isModalOpen = true;
      state.isThinking = true;
      state.analysisResult = null;
      state.error = null;
      state.analysisType = payload?.analysisType || null;
    },
    closeModal(state) {
      state.isModalOpen = false;
      state.isThinking = false;
      state.analysisResult = null;
      state.error = null;
      state.analysisType = null;
    },
    setThinking(state, { payload }) {
      state.isThinking = payload;
    },
    setAnalysisResult(state, { payload }) {
      state.analysisResult = payload;
      state.isThinking = false;
      state.error = null;
    },
    setAnalysisError(state, { payload }) {
      state.error = payload;
      state.isThinking = false;
    },
    setActiveTab(state, { payload }) {
      state.activeTab = payload;
    },
    resetAnalysis(state) {
      state.isThinking = false;
      state.analysisResult = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(analyzeWithAI.pending, (state) => {
      state.isThinking = true;
      state.error = null;
      })
    .addCase(analyzeWithAI.fulfilled, (state, { payload }) => {
      state.isThinking = false;
      state.analysisResult = payload;
      state.error = null;
    })
    .addCase(analyzeWithAI.rejected, (state, { payload }) => {
      state.isThinking = false;
      state.error = payload;
    })
  }
});

export const {
  openModal,
  closeModal,
  setThinking,
  setAnalysisResult,
  setAnalysisError,
  resetAnalysis,
  setActiveTab,
} = aiAnalysisSlice.actions;

export default aiAnalysisSlice.reducer;
